import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import { Backend } from "../services/Backend";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { SuccessToast } from "../utils/utils";
import moment from "moment";

export default function AdminApproveUrlPage() {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [urls, setUrls] = useState([]);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);

    Backend.get(`url/pending?page=${newPage}`)
      .then(res => {
        setTotalCount(res.totalCount);
        setUrls(res.data);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    Backend.get(`url/pending?page=${page}`)
      .then(res => {
        setTotalCount(res.totalCount);
        console.log(res.data);
        setUrls(res.data);
        setIsLoading(false);
      });
  }, []);

  const handleAccept = (e, id) => {
    e.preventDefault();
    e.stopPropagation();

    Backend.put(`url/${id}/approve`)
      .then(res => {
        SuccessToast("URL approved");
        setTimeout(() => navigate(0), 1000);
      });
  }

  const handleReject = (e, id) => {
    e.preventDefault();
    e.stopPropagation();

    Backend.delete(`url/${id}/`)
      .then(res => {
        SuccessToast("URL rejected");
        setTimeout(() => navigate(0), 1000);
      });
  }

  const goToPreviewPage = (row) => {
    navigate(`/url/${row.id}`);
  }

  return <div>
    <h2 className="text-2xl font-bold mb-4">Pending URLs</h2>
    {isLoading ? <div className="mx-auto mt-4 w-fit"><Loader /></div> : <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow className="bg-slate-950">
              <TableCell>Id</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Upload Date</TableCell>
              <TableCell>Uploaded By</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {urls.map((row) => (
              <TableRow key={row.id} onClick={() => goToPreviewPage(row)}>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.title}</TableCell>
                <TableCell>{moment(row.uploadDate).format('DD/MM/YYYY')}</TableCell>
                <TableCell>
                  <Link 
                    onClick={(e) => e.stopPropagation()}
                    className="text-blue-600 hover:underline" 
                    to={`/dashboard/users/${row.authorId}`}
                  >
                    Open User Page
                  </Link>
                </TableCell>
                <TableCell>
                  <div className="flex gap-2">
                    <CheckCircleIcon 
                      className="text-green-600 cursor-pointer" 
                      onClick={(e) => handleAccept(e, row.id)}
                    />
                    <CancelIcon 
                      className="text-red-600 cursor-pointer" 
                      onClick={(e) => handleReject(e, row.id)}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={10}
        component="div"
        count={totalCount}
        rowsPerPage={10}
        page={page}
        onPageChange={handleChangePage}
      />
    </>}
  </div>
}